module.exports = __webpack_public_path__ + "static/media/YM75_5.f024f89b.jpg";